var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-chip-set",
    { attrs: { input: true } },
    _vm._l(_vm.chipset, function(chip) {
      return _c(
        "m-chip",
        { key: chip.chip },
        [
          chip.icon
            ? _c("m-icon", {
                attrs: { slot: chip.icon.slot, icon: chip.icon.icon },
                slot: chip.icon.slot
              })
            : _vm._e(),
          _vm._v("\n    " + _vm._s(chip.chip) + "\n  ")
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }